module.exports = __webpack_public_path__ + "assets/rxjs.f7177acb.svg";